import { useQuery } from '@tanstack/react-query';
import { fetchShipmentTypes } from '../data-provider/shipment-types';

export const useGetShipmentTypes = () => {
  return useQuery({
    queryKey: ['shipment-types'],
    queryFn: () => fetchShipmentTypes(),
    staleTime: 1000 * 60 * 60 * 24, // 1 day
  });
};
